import { render, staticRenderFns } from "./ShouYi.vue?vue&type=template&id=e511ac48&scoped=true&"
import script from "./ShouYi.vue?vue&type=script&lang=js&"
export * from "./ShouYi.vue?vue&type=script&lang=js&"
import style0 from "./ShouYi.vue?vue&type=style&index=0&id=e511ac48&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e511ac48",
  null
  
)

export default component.exports